import { Locale, K } from "../constants";

const locale: Locale = {
  [K.COPY_TOOLTIP]: "Copy",
  [K.EXPORT_TOOLTIP]: "Download",
};

export default locale;
